import CompareWellbySavAccBlock from './CompareWellbySavAccBlock'
import CompareWellbySavAccCardBlock from './CompareWellbySavAccCardBlock'

export { CompareWellbySavAccBlock, CompareWellbySavAccCardBlock }
